import { createComponent } from '@helpers/admin';
import component from '@template/blocks/domain/DomainNameSearchResults';

export const DomainNameSearchResults = createComponent({
  label: 'Search Results',
  component,
  fields: {
    header: {
      label: 'Header',
      type: 'object',
      objectFields: {
        title: {
          label: 'Title',
          type: 'text',
        },
        subTitle: {
          label: 'Sub Title',
          type: 'text',
        },
      },
    },
    available: {
      label: 'Available',
      type: 'object',
      objectFields: {
        title: {
          label: 'Title',
          type: 'text',
        },
        button: {
          label: 'Button',
          type: 'button',
        },
      },
    },
    unavailable: {
      label: 'Available',
      type: 'object',
      objectFields: {
        title: {
          label: 'Title',
          type: 'text',
        },
        button: {
          label: 'Button',
          type: 'button',
        },
      },
    },
  },
});
